import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { SearchContext } from "../contexts/SearchContext";
import { LoadingContext } from "../contexts/LoadingContext";
import { PaginationResponse } from "../objects/pagination";
import { useNavigate } from "react-router-dom";
import { getWithdrawals } from "../services/sales/WithdrawalApi";
import { getPagination, money, statusColorMap } from "../utils/helper";
import { errorToast } from "../utils/helper-ui";
import { Withdrawal } from "../models/sales/withdrawal";
import { Button, Checkbox, IconButton, Pagination, Table } from "rsuite";
import { BsTrash3 } from "react-icons/bs";
const { Column, HeaderCell, Cell } = Table;
interface WithdrawalPageProps {}

const WithdrawalPage: FC<WithdrawalPageProps> = ({}) => {
  const { search, setSearch } = useContext(SearchContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [mounted, setMounted] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(30);
  const [pagination, setPagination] = useState<PaginationResponse>();
  const [withdrawals, setWithdrawals] = useState<Withdrawal[]>([]);
  //   const [modalFormOpen, setModalFormOpen] = useState(false);
  //   const [selectedSales, setSelectedSales] = useState<Sales>();
  const nav = useNavigate();

  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === withdrawals.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (
    checkedKeys.length > 0 &&
    checkedKeys.length < withdrawals.length
  ) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? withdrawals.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    fetchData();
  }, [mounted, search, page, size]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await getWithdrawals({ page, size, search });
      const resJson = await res.json();
      //   console.log(data);
      setWithdrawals((prev) => [...prev, ...resJson.data.items]);
      setPagination(getPagination(resJson.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Withdrawal</h1>
      {/* button */}
      <div>
        {/* <IconButton
              size="sm"
              appearance="primary"
              color="green"
              icon={<PlusIcon />}
              onClick={() => setModalFormOpen(true)}
            >
              Create Sales
            </IconButton> */}
      </div>
    </div>
  );

  return (
    <MainLayout header={renderHeader()}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th
                className="px-4 py-2 text-left border bg-gray-50"
                style={{ width: 100 }}
              >
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Code</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Total</th>
              <th className="px-4 py-2 text-left border bg-gray-50">
                Merchant
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Status</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Action</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map((rowData, i) => (
              <tr key={i}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={rowData.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((item) => item === rowData.id)}
                  />
                  {i + 1}
                </td>

                <td
                  className="px-4 py-2 border"
                  onClick={() => nav(`/withdrawal/${rowData.id}`)}
                >
                  {rowData.code}
                </td>
                <td>{money(rowData.total)}</td>
                <td
                  className="px-4 py-2 border"
                  onClick={() => nav(`/merchant/${rowData.merchant?.id}`)}
                >
                  {rowData.merchant?.name}
                </td>
                <td className="px-4 py-2 border">
                  <div
                    className={`px-2 rounded ${
                      statusColorMap[
                        rowData.status as keyof typeof statusColorMap
                      ] || ""
                    }`}
                  >
                    {rowData.status}
                  </div>
                </td>
                <td className="px-4 py-2 border">
                  <BsTrash3
                    className="text-red-500 hover:text-red-800 cursor-pointer"
                    size={16}
                    onClick={() => {
                      // removeSales(rowData as Sales)
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!pagination?.last && (
        <div className="flex justify-center my-2">
          <Button
            onClick={() => {
              setPage((pagination?.page ?? 0) + 1);
            }}
          >
            Load more
          </Button>
        </div>
      )}
      {/* <Table minHeight={700} data={withdrawals} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>
                {(page - 1) * size +
                  withdrawals.indexOf(rowData as Withdrawal) +
                  1}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Code</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  nav(`/withdrawal/${rowData.id}`);
                }}
              >
                {rowData.code}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Total</HeaderCell>
          <Cell>{(rowData) => <div>{money(rowData.total)}</div>}</Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Merchant</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  nav(`/merchant/${rowData.merchant?.id}`);
                }}
              >
                {rowData.merchant?.name}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={150} resizable>
          <HeaderCell align="center">Status</HeaderCell>
          <Cell style={{ padding: 3 }}>
            {(rowData) => {
              const statusColor =
                statusColorMap[rowData.status as keyof typeof statusColorMap] ??
                "";
              return (
                <div
                  className={`text-white text-center ${statusColor} p-2 rounded`}
                >
                  {rowData.status}
                </div>
              );
            }}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {(rowData) => (
              <BsTrash3
                className="text-red-500 hover:text-red-800"
                size={16}
                onClick={() => {
                  // removeSales(rowData as Sales)
                }}
              />
            )}
          </Cell>
        </Column>
      </Table> */}
      {/* <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={pagination?.total ?? 0}
          limitOptions={[10, 30, 50]}
          limit={pagination?.size}
          activePage={pagination?.page}
          onChangePage={setPage}
          onChangeLimit={setSize}
        />
      </div> */}
    </MainLayout>
  );
};
export default WithdrawalPage;
